import React, { createContext, useState, useContext, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [showMarginPrice, setShowMarginPrice] = useState(() => {
    const saved = localStorage.getItem('showMarginPrice');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [showWholesalePrice, setShowWholesalePrice] = useState(() => {
    const saved = localStorage.getItem('showWholesalePrice');
    return saved ? JSON.parse(saved) : false;
  });
  
  const [desiredMarginPercentage, setDesiredMarginPercentage] = useState(() => {
    const saved = localStorage.getItem('desiredMarginPercentage');
    return saved ? parseFloat(saved) : 20;
  });

  useEffect(() => {
    localStorage.setItem('showMarginPrice', JSON.stringify(showMarginPrice));
  }, [showMarginPrice]);

  useEffect(() => {
    localStorage.setItem('showWholesalePrice', JSON.stringify(showWholesalePrice));
  }, [showWholesalePrice]);

  useEffect(() => {
    localStorage.setItem('desiredMarginPercentage', desiredMarginPercentage.toString());
  }, [desiredMarginPercentage]);

  const formatPriceWithMargin = (wholesalePrice) => {
    if (!wholesalePrice) return null;
    const marginMultiplier = 1 + (desiredMarginPercentage / 100);
    const salePrice = wholesalePrice * marginMultiplier;
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(salePrice);
  };

  const value = {
    showMarginPrice,
    setShowMarginPrice,
    showWholesalePrice,
    setShowWholesalePrice,
    desiredMarginPercentage,
    setDesiredMarginPercentage,
    formatPriceWithMargin
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
